import { useState } from 'react';
import { yearStats } from '@/mocks/gossip';

const yearGradient: Record<string, string> = {
  '2024': 'from-primary-600 to-primary-400',
  '2025': 'from-accent-500 to-accent-300',
  '2026': 'from-secondary-600 to-secondary-400',
};

export default function AnnualSummary() {
  const [active, setActive] = useState('2025');
  const stat = yearStats.find((s) => s.year === active) || yearStats[1];

  return (
    <section id="annual" className="scroll-mt-24 py-10 md:py-14 bg-background-50">
      <div className="container-site">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-8 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium tracking-widest text-foreground-500">YEAR IN REVIEW</span>
            <span className="w-8 h-1.5 rounded-full bg-accent-500"></span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">吃瓜黑料<span className="text-primary-600">年度汇总</span></h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">每一年都有它的关键词，点一下年份，回看那年热闹与崩塌并存的记忆。</p>
        </div>

        {/* 年份选择 */}
        <div className="flex items-center justify-center gap-2 p-1.5 bg-background-100 border border-background-200 rounded-full w-fit mx-auto mb-8">
          {yearStats.map((s) => (
            <button
              key={s.year}
              onClick={() => setActive(s.year)}
              className={`px-6 py-2 rounded-full text-sm font-semibold transition whitespace-nowrap ${
                active === s.year ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {s.year}
            </button>
          ))}
        </div>

        <div key={stat.year} className="grid grid-cols-1 lg:grid-cols-2 gap-6 animate-fade-up">
          {/* 封面卡 */}
          <div className={`rounded-2xl bg-gradient-to-br ${yearGradient[stat.year]} p-6 md:p-8 text-background-50 relative overflow-hidden`}>
            <span className="absolute -right-4 -top-8 font-display text-[160px] text-background-50/15 leading-none">{stat.year}</span>
            <div className="relative">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 text-sm">
                <i className="ri-calendar-check-line"></i> 年度盘点 · {stat.year}
              </span>
              <h3 className="mt-4 text-2xl md:text-3xl font-bold">{stat.label}</h3>
              <p className="mt-3 text-background-50/85 leading-relaxed max-w-md">{stat.desc}</p>
              <div className="mt-6 flex items-center gap-6">
                <div>
                  <div className="font-display text-4xl leading-none">{stat.events}</div>
                  <div className="mt-1 text-sm text-background-50/75">全年收录事件</div>
                </div>
                <div className="w-px h-12 bg-background-50/30"></div>
                <div>
                  <div className="text-sm font-medium">年度头号话题</div>
                  <div className="mt-1 text-background-50/90 text-sm">{stat.topTopic}</div>
                </div>
              </div>
            </div>
          </div>

          {/* 年度关键词 */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8 flex flex-col justify-center">
            <span className="text-xs font-medium tracking-widest text-foreground-400">年度关键词</span>
            <div className="mt-4 flex flex-wrap gap-3">
              {stat.hotWords.map((w) => (
                <span key={w} className="px-5 py-2.5 rounded-xl bg-primary-100 text-primary-700 font-semibold text-lg">
                  #{w}
                </span>
              ))}
            </div>
            <div className="mt-7 space-y-3">
              {[
                { label: '讨论总热度', value: '同比增长 142%', icon: 'ri-fire-fill' },
                { label: '事件平均发酵周期', value: '3.2 天', icon: 'ri-time-line' },
                { label: '用户站队比例', value: '中立派 61%', icon: 'ri-scales-3-line' },
              ].map((row) => (
                <div key={row.label} className="flex items-center justify-between py-3 border-b border-background-100">
                  <span className="flex items-center gap-2 text-foreground-600 text-sm"><i className={`${row.icon} text-primary-500`}></i> {row.label}</span>
                  <span className="text-sm font-semibold text-foreground-900">{row.value}</span>
                </div>
              ))}
            </div>
            <a href="#major" className="mt-6 inline-flex items-center justify-center gap-1.5 h-11 rounded-xl bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition whitespace-nowrap">
              阅读 {stat.year} 大事件回顾 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}